export const PRODUCT_CATEGORY_GA = {
    PAID: 'Paid',
    FREE: 'Free',
    VIEW_ONLY: 'ViewOnly',
};

export const DEFAULT_BILLING_PERIOD = 'Daily';

// biome-ignore lint/style/noEnum: Preserve the established enum values and runtime API used by existing callers
export enum ProductType {
    ASSET_BASED = 'ASSET_BASED',
    USER_BASED = 'USER_BASED',
}
